import './Link.scss';

import type { FC } from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router';
import { omit } from 'lodash-es';
import classNames from 'classnames';

interface Props extends LinkProps {
  button?: boolean;
  testID?: string;
}

const Link: FC<Props> = (props) => {
  const className = classNames(
    'Link',
    {
      'Link--button': props.button,
    },
    props.className,
  );

  if (
    typeof props.to === 'string' &&
    (props.to.startsWith('#') || /^https?:/.test(props.to))
  ) {
    return (
      <a
        {...omit(props, ['to', 'button', 'testID'])}
        href={props.to}
        className={className}
        data-test-id={props.testID}
      >
        {props.children}
      </a>
    );
  } else {
    return (
      <ReactRouterLink
        {...omit(props, ['button', 'testID'])}
        className={className}
        data-test-id={props.testID}
      >
        {props.children}
      </ReactRouterLink>
    );
  }
};

export default Link;
